import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  allVirtualMachines: [{}],
  downloadVirtualMachinesData: [{}],
  opennebulaVirtualMachine: [{}],
  opennebulaCustomerVirtualMachine: [{}],
  virtualMachine: {},
  virtualMachineRowData: {},
  virtualMachineWithSiteIDS: [],
  newVirtualMachine: {},
  newCustomVirtualMachine: {},
  updatedVirtualMachine: {},
  deleteVirtualMachine: {},
  vmstarted: [],
  vmended: [],
  vmConsole: {},
  customerVMUsage: [],
  allvminfo: {},
  customervminfo: {},
  retireVM: {},
  opennebulaVirtualMachineById: {},
  opennebulaVirtualMachineMonitoringById: {},
  opennebulaVirtualNetworkById: {},
  addStorageToggle: false,
  isLoading: false,
  isUsageLoading: false,
  error: null,
  detachedVirtualMachine: null,
  refreshVirtualMachine: {},
  totalVmQuota: {},
  VmStatus: {},
  vmRemainingQuota: {},
  customerVMQuotaByVM: {},
  filterCustomerVMQuotaByVM: [],
  consoleUrl: '',
};

const virtualMachineSlice = createSlice({
  name: 'virtualMachine',
  initialState,
  reducers: {
    start: (state, action) => {
      state.error = [];
      state.isLoading = true;
    },
    startUsage: (state, action) => {
      state.error = [];
      state.isUsageLoading = true;
    },
    stopUsage: (state, action) => {
      state.error = [];
      state.isUsageLoading = false;
    },
    setReducerError: (state, action) => {
      state.error = action.payload;
      state.isLoading = false;
    },
    setTotalVmQuota: (state, action) => {
      state.totalVmQuota = action.payload;
      state.error = null;
      state.isLoading = false;
    },
    setVirtualMachineRowData: (state, action) => {
      state.virtualMachineRowData = action.payload;
      state.error = null;
      state.isLoading = false;
    },
    setVmStatus: (state, action) => {
      state.VmStatus = action.payload;
      state.error = null;
      state.isLoading = false;
    },
    setVmRemainingQuota: (state, action) => {
      state.vmRemainingQuota = action.payload;
      state.error = null;
      state.isLoading = false;
    },
    setCustomerVMQuotaByVM: (state, action) => {
      state.customerVMQuotaByVM = action.payload;
      state.error = null;
      state.isUsageLoading = false;
    },
    setRefreshVirtualMachine: (state, action) => {
      state.refreshVirtualMachine = action.payload;
      state.error = null;
      state.isLoading = false;
    },
    setDeleteUserAndProfileFailure: (state, action) => {
      state.error = action.error;
      state.isLoading = false;
    },
    setAllVirtualMachines: (state, action) => {
      state.allVirtualMachines = action.payload;
      state.error = null;
      state.isLoading = false;
    },
    setDownloadVirtualMachinesData: (state, action) => {
      state.downloadVirtualMachinesData = action.payload;
      state.error = null;
      state.isLoading = false;
    },
    setVirtualMachine: (state, action) => {
      state.virtualMachine = action.payload;
      state.error = null;
      state.isLoading = false;
    },
    setDetachedVirtualMachine: (state, action) => {
      state.detachedVirtualMachine = action.payload;
      state.error = null;
      state.isLoading = false;
    },
    setNewVirtualMachine: (state, action) => {
      state.newVirtualMachine = action.payload;
      state.error = null;
      state.isLoading = false;
    },
    setUpdatedVirtualMachine: (state, action) => {
      state.updatedVirtualMachine = action.payload;
      state.error = null;
      state.isLoading = false;
    },
    setAllVmTemplates: (state, action) => {
      state.allvmtemplates = action.payload;
      state.error = null;
      state.isLoading = false;
    },
    setCustomerVms: (state, action) => {
      state.customervms = action.payload;
      state.error = null;
      state.isLoading = false;
    },
    setVirtualMachineWithSiteIDS: (state, action) => {
      state.virtualMachineWithSiteIDS = action.payload;
      state.error = null;
      state.isLoading = false;
    },
    setDeleteVirtualMachine: (state, action) => {
      state.deleteVirtualMachine = action.payload;
      state.error = null;
      state.isLoading = false;
    },
    setNewCustomVirtualMachine: (state, action) => {
      state.newCustomVirtualMachine = action.payload;
      state.error = null;
      state.isLoading = false;
    },
    setVmStarted: (state, action) => {
      state.vmstarted = action.payload;
      state.error = null;
      state.isLoading = false;
    },
    setVmEnded: (state, action) => {
      state.vmended = action.payload;
      state.error = null;
      state.isLoading = false;
    },
    setVmConsole: (state, action) => {
      state.vmConsole = action.payload;
      state.error = null;
      state.isLoading = false;
    },
    setAllVmInfo: (state, action) => {
      state.allvminfo = action.payload;
      state.error = null;
      state.isLoading = false;
    },
    setCustomerVmInfo: (state, action) => {
      state.customervminfo = action.payload;
      state.error = null;
      state.isLoading = false;
    },
    setOpennebulaVirtualMachine: (state, action) => {
      state.opennebulaVirtualMachine = action.payload;
      state.error = null;
      state.isLoading = false;
    },
    setOpennebulaCustomerVirtualMachine: (state, action) => {
      state.opennebulaCustomerVirtualMachine = action.payload;
      state.error = null;
      state.isLoading = false;
    },
    setOpennebulaVirtualMachineById: (state, action) => {
      state.opennebulaVirtualMachineById = action.payload;
      state.isLoading = false;
      state.error = null;
    },
    setOpennebulaVirtualMachineMonitoringById: (state, action) => {
      state.opennebulaVirtualMachineMonitoringById = action.payload;
      state.error = null;
      state.isLoading = false;
    },
    setOpennebulaVirtualNetwork: (state, action) => {
      state.opennebulaVirtualNetwork = action.payload;
      state.error = null;
      state.isLoading = false;
    },
    setOpennebulaVirtualNetworkCustomer: (state, action) => {
      state.opennebulaVirtualNetworkCustomer = action.payload;
      state.error = null;
      state.isLoading = false;
    },
    setOpennebulaVirtualNetworkById: (state, action) => {
      state.opennebulaVirtualNetworkById = action.payload;
      state.error = null;
      state.isLoading = false;
    },
    setVirtualNetworkById: (state, action) => {
      state.virtualNetworkById = action.payload;
      state.error = null;
      state.isLoading = false;
    },
    setVMUsageHistoryByCustomer: (state, action) => {
      state.customerVMUsage = action.payload;
      state.error = null;
      state.isLoading = false;
    },
    setConsoleById: (state, action) => {
      state.consoleById = action.payload;
      state.error = null;
      state.isLoading = false;
    },
    setRetireVM: (state, action) => {
      state.retireVM = action.payload;
      state.error = null;
      state.isLoading = false;
    },
    setConsoleUrl: (state, action) => {
      state.consoleUrl = action.payload;
      state.error = null;
      state.isLoading = false;
    },
    setToggleStorage: (state, action) => {
      state.addStorageToggle = !state.addStorageToggle;
    },
    setFilterCustomerVMQuotaByVM: (state, action) => {
      state.filterCustomerVMQuotaByVM = action.payload;
      state.error = null;
      state.isUsageLoading = false;
    },
    setResetVirtualMachine: () => {
      return initialState;
    },
  },
});

export const {
  start,
  startUsage,
  stopUsage,
  setReducerError,
  setTotalVmQuota,
  setVmStatus,
  setVmRemainingQuota,
  setCustomerVMQuotaByVM,
  setRefreshVirtualMachine,
  setDeleteUserAndProfileFailure,
  setAllVirtualMachines,
  setVirtualMachine,
  setDetachedVirtualMachine,
  setNewVirtualMachine,
  setUpdatedVirtualMachine,
  setAllVmTemplates,
  setCustomerVms,
  setVirtualMachineWithSiteIDS,
  setDeleteVirtualMachine,
  setNewCustomVirtualMachine,
  setVmStarted,
  setVmEnded,
  setVmConsole,
  setAllVmInfo,
  setCustomerVmInfo,
  setOpennebulaVirtualMachine,
  setOpennebulaCustomerVirtualMachine,
  setOpennebulaVirtualMachineById,
  setOpennebulaVirtualMachineMonitoringById,
  setVMUsageHistoryByCustomer,
  setOpennebulaVirtualNetwork,
  setOpennebulaVirtualNetworkCustomer,
  setOpennebulaVirtualNetworkById,
  setVirtualNetworkById,
  setConsoleById,
  setToggleStorage,
  setRetireVM,
  setDownloadVirtualMachinesData,
  setVirtualMachineRowData,
  setConsoleUrl,
  setResetVirtualMachine,
  setFilterCustomerVMQuotaByVM,
} = virtualMachineSlice.actions;

export default virtualMachineSlice.reducer;
